import { useEffect, useMemo } from "react";

import { Application } from "@platformsh/observability-graph/ContinuousProfiling";

import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

const useConprofProfileTypesPoll = ({
  service,
  timeframe,
  onChange,
  onError,
  onLoadingChange,
  interval = 30
}: MetricsPollType<Application | null> & {
  service: string;
}) => {
  const client = useObservabilityPipelineHttpClient();

  const poller = useMemo(
    () => new Poller({ onChange, onError, onLoadingChange }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    async function fetchContinuousProfilingApps() {
      if (client === null) {
        return Promise.reject("Null value");
      }

      const response = await client.getContinuousProfilingApps();

      return response.applications[service] ?? null;
    }

    timeframe.id
      ? poller.startPolling(fetchContinuousProfilingApps, interval)
      : poller.pollOnce(fetchContinuousProfilingApps);
  }, [client, timeframe, interval, poller, service]);

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);

  return poller;
};

export default useConprofProfileTypesPoll;
